import styled from "styled-components";

import { motion } from "framer-motion";
import animations from "../../../../utils/animation";

export const Container = styled.div`
  width: 400px;
  max-height: 600px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 5px;

  padding: 40px 10px;

  @media (max-width: 1024px) {
    margin-top: 30px;
    height: 90vh;
    max-height: 90vh;
  }
`;

export const ButtonBack = styled.button`
  cursor: pointer;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: transparent;
`;

export const LabelBack = styled.p`
  margin-left: 10px;
  color: #707070;
`;

export const IconBack = styled.img`
  width: 20px;
  height: 20px;
`;

export const ListPatient = styled(motion.div).attrs(animations)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 90%;
  overflow: auto;
  @media (max-width: 1024px) {
    flex-direction: column;
    height: 100%;
  }
`;

export const PatientSection = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 10px 5px;
  padding: 0 0 5px;
  border-bottom: 1px solid #ddd;
  width: 90%;
  min-width: 300px;

  @media (max-width: 1024px) {
    width: 100%;
    min-width: 100%;
    margin: 10px 0;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  }

  &:hover {
    transition: 0.3s;
    opacity: 0.7;
  }
`;

export const ButtoAddPatient = styled.button`
  min-width: 46px;
  width: 46px;
  height: 46px;
  margin: 5px;

  border-radius: 46px;
  background: #2196f3;
`;

export const ImgButtonAddPatient = styled.img`
  width: 22px;
  height: 22px;
`;

export const ImagePatient = styled.img`
  min-width: 46px;
  width: 46px;
  height: 46px;
  border-radius: 46px;
  margin: 5px;
`;

export const NamePatient = styled.div`
  color: #000;
  font-size: 12px;
  margin: 5px;

  @media (max-width: 1024px) {
    font-size: 14px;
    font-weight: bold;
    margin: 5px;
  }
`;

export const DivArrow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
